<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>dynamic_form</mat-icon>
				<span>Formulare</span>
			</div>

			@if( bDeletingOne || bLoading ) {
				<mat-spinner diameter=30 />
			}

			<div style="display: flex; flex-flow: row wrap; gap: 1em">

				<button
					mat-raised-button
					[routerLink]="[ 'bearbeiten' ]"
					[disabled]="bDeletingOne || bLoading"
				>
					<div class="iconAndTxt">
						<span class="material-icons">add</span>
						<span>Erstellung</span>
					</div>
				</button>

			</div>

		</div>

		@if( !bLoading ) {
	
			@if( !forms.length ) {

				<div class="noResults" style="text-align: center;">
					Keine Formulare
				</div>

			}
			@else {

				<div class="formPanel">

					@for( form of forms; track form.fkId ) {
	
						<div class="formRow">

							<div
								class="formLink"
								[routerLink]="[ 'bearbeiten', form.fkId ]"
							>
								{{ (form.fkBezeichnung && form.fkBezeichnung.trim()) ? form.fkBezeichnung : '(' + form.fkId + ')' }} 
							</div>

							@if( bDeleting[ form.fkId ] ) {
								<mat-spinner diameter="20" />
							}
							@else {
								<span
									class="material-icons iconBtn"
									title="Formular entfernen"
									style="opacity: .5;"
									(click)="clickDeleteForm( form.fkId )"
								>
									delete
								</span>
							}

						</div>

					}

				</div>

				@if( bDeleteError ) {
					
					<div class="errorWarning" style="text-align: center;">
						Beim Entfernen des Formulars ist ein Fehler aufgetreten
					</div>

				}

			}

		}

	</div>

</div>

